export const FETCH_PAYMENT_DETAIL_REQUESTED = 'FETCH_PAYMENT_DETAIL_REQUESTED';
export const FETCH_PAYMENT_DETAIL_SUCCEEDED = 'FETCH_PAYMENT_DETAIL_SUCCEEDED';
export const CREATE_PAYMENT_ITEM_REQEUSTED = 'CREATE_PAYMENT_ITEM_REQUESTED';
export const CREATE_PAYMENT_ITEM_SUCCEEDED = 'CREATE_PAYMENT_ITEM_SUCCEEDED';
export const TOGGLE_PAYMENT_TYPE = 'TOGGLE_PAYMENT_TYPE';
